import initialState from "app/initialState";
import { ReducerBase } from "common/reducer";
import { MarketHoliday, MarketScheduleItem } from "./marketScheduleService";
import { ByCommodityGroup } from "app/IAppStore";
import { MarketHolidaysLoaded, MarketScheduleLoaded } from "./market.actions";

export class MarketScheduleReducer extends ReducerBase<ByCommodityGroup<MarketScheduleItem[]>> {

    constructor() {
        super();
        this.addHandler(MarketScheduleLoaded.EventName, this.handleMarketScheduleLoaded);
    }

    handleMarketScheduleLoaded(state: ByCommodityGroup<MarketScheduleItem[]> = initialState.marketSchedule, event: MarketScheduleLoaded): ByCommodityGroup<MarketScheduleItem[]> {
        const newState = {...state};
        newState[event.commodityGroupId] = event.marketSchedule;
        return newState;
    }

    handleDefault(state: ByCommodityGroup<MarketScheduleItem[]> = initialState.marketSchedule): ByCommodityGroup<MarketScheduleItem[]> {
        return state;
    }
} 

export class MarketHolidaysReducer extends ReducerBase<ByCommodityGroup<MarketHoliday[]>> {

    constructor() {
        super();
        this.addHandler(MarketHolidaysLoaded.EventName, this.handleMarketHolidaysLoaded);
    }

    handleMarketHolidaysLoaded(state: ByCommodityGroup<MarketHoliday[]> = initialState.marketHolidays, event: MarketHolidaysLoaded): ByCommodityGroup<MarketHoliday[]> {
        const newState = {...state};
        newState[event.commodityGroupId] = event.marketHolidays;
        return newState;
    }

    handleDefault(state: ByCommodityGroup<MarketHoliday[]> = initialState.marketHolidays): ByCommodityGroup<MarketHoliday[]> {
        return state;
    }
} 